import React, { useState } from 'react';
import { Spinner } from 'app/src/components/Spinner';
import { Upload } from './Upload';
import { UnsplashSearch } from './UnsplashSearch';

interface AddCoverProps {
  cardId: string;
  navigateToSelectCover: () => void;
}

export const AddCover: React.FunctionComponent<AddCoverProps> = ({
  cardId,
  navigateToSelectCover,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  if (isUploading) {
    return <Spinner centered />;
  }

  const onSetCover = () => {
    navigateToSelectCover();
  };

  return (
    <>
      <UnsplashSearch
        cardId={cardId}
        onSetCover={onSetCover}
        onSetSearching={setIsSearching}
      />
      {!isSearching && (
        <Upload
          cardId={cardId}
          onFileSelected={() => {
            setIsUploading(true);
          }}
          onFileUploaded={() => {
            onSetCover();
          }}
        />
      )}
    </>
  );
};
